import IJitRepository from '../domain/IJitRepository';
import TransitsData from '../domain/TransitsData';
import jitRepository from '../infrastructure/repositories/JitRepository';

class GetTransitsService {
  private readonly _jitRepository: IJitRepository;

  constructor({ repository }) {
    this._jitRepository = repository;
  }

  execute({ queryParams }: { queryParams: object }) {
    return this._jitRepository
      .getJitLoadsByPiece({ queryParams })
      .then((res) => TransitsData.generateFromDTO(res));
  }
}

export default new GetTransitsService({ repository: jitRepository });

export { GetTransitsService };
